import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { paperWithTopLabelAndBottomValue } from '../uiComponent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
  humanNamePrefixOptionsOptionsList,
  humanNameSuffixOptionsList,
} from '../../../data/fhirHumanNameData';
import {
  AutoCompleteWithTopLabel,
  TextFieldWithTopLabelComponent,
} from '../uiComponent/fhirComponentUi';
import { useDispatch } from 'react-redux';
import {
  resetStateDetectorState,
  setStateDetectorState,
} from '../../../redux/features/stateDetectorSlice';
import { capitalizeFirstLetter } from '../../../config/common';

const humanNameInitalState = patientObject => {
  debugger;
  if (!_.isEmpty(patientObject)) {
    const displaySuffixList = !_.isEmpty(patientObject?.suffix)
      ? patientObject?.suffix?.map(item => ({
          code: item,
          display: item,
        }))
      : [];

    return {
      use: patientObject?.use, // usual | official | temp | nickname | anonymous | old | maiden
      text: !_.isUndefined(patientObject?.text) ? patientObject?.text : '', // Text representation of the full name
      family: !_.isUndefined(patientObject?.family)
        ? patientObject?.family
        : '', // Family name (often called 'Surname')
      given: patientObject?.given, // Given names (not always 'first'). Includes middle names//array
      prefix: patientObject?.prefix, // Parts that come before the name//array
      suffix: patientObject?.suffix, // Parts that come after the name//array
      // period: patientObject?.period, // Time period when name was/is in use
      firstName: !_.isUndefined(patientObject?.given?.[0])
        ? patientObject?.given?.[0]
        : '',
      middleName: !_.isUndefined(patientObject?.given?.[1])
        ? patientObject?.given?.[1]
        : '',
      lastName: !_.isUndefined(patientObject?.family)
        ? patientObject?.family
        : '',
      // displayPrefix: !_.isUndefined(patientObject?.prefix?.[0])
      //   ? patientObject?.prefix?.[0]
      //   : '',
      // displaySuffix: !_.isUndefined(patientObject?.suffix?.[0])
      //   ? patientObject?.suffix?.[0]
      //   : '',

      displayPrefix: !_.isUndefined(patientObject?.prefix?.[0])
        ? {
            code: patientObject?.prefix?.[0],
            display: patientObject?.prefix?.[0],
          }
        : null,
      displaySuffix: displaySuffixList,
    };
  } else {
    return {
      use: '', // usual | official | temp | nickname | anonymous | old | maiden
      text: '', // Text representation of the full name
      family: '', // Family name (often called 'Surname')
      given: [], // Given names (not always 'first'). Includes middle names//array
      prefix: [], // Parts that come before the name//array
      suffix: [], // Parts that come after the name//array
      // period: {}, // Time period when name was/is in use
      firstName: '',
      middleName: '',
      lastName: '',
      // displayPrefix: humanNamePrefixOptionsOptionsList?.[0]?.code,
      // displaySuffix: humanNameSuffixOptionsList?.[0]?.code,
      displayPrefix: null,
      displaySuffix: [],
    };
  }
};

const useInitialState = [
  'usual',
  'official',
  'temp',
  'nickname',
  'anonymous',
  'old',
  'maiden',
];
const FHIRHumanName = forwardRef((props, ref) => {
  const [initialState, setInitialState] = useState({});
  const [isStateChanged, setIsStateChanged] = useState(false);
  const { stateChangeActive = true } = props;

  const { isEdit, npiData } = props;

  const [humanNameState, setHumanNameState] = useState(
    humanNameInitalState(props?.nameObject)
  );

  const reduxDispatch = useDispatch();

  useEffect(() => {
    setInitialState(humanNameState);
  }, []);

  useEffect(() => {
    if (stateChangeActive) {
      const flag =
        JSON.stringify(initialState) !== JSON.stringify(humanNameState);
      setIsStateChanged(flag);
      reduxDispatch(setStateDetectorState({ isHumanNameStateChanged: flag }));
      console.log(
        `IS_STATE_CHANGE_HUMAN_NAME`,
        flag,
        'STATE',
        initialState,
        humanNameState
      );
    }

    return () => {
      reduxDispatch(resetStateDetectorState());
    };
  }, [initialState, humanNameState]);

  const firstNameRef = useRef(null);
  const middleNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const prefixRef = useRef(null);
  const suffixRef = useRef(null);

  const firstNameValidationObject = {
    name: 'firstName',
    label: 'First Name',
    value: humanNameState?.firstName,
    validation: {
      required: true,
      min: 1,
      max: 35,
    },
    ref: firstNameRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
  };

  const middleNameValidationObject = {
    name: 'middleName',
    label: 'Middle Name',
    value: humanNameState?.middleName,
    validation: {
      required: false,
      min: 1,
      max: 25,
    },
    ref: middleNameRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
  };

  const lastNameValidationObject = {
    name: 'lastName',
    label: 'Last Name',
    value: humanNameState?.lastName,
    validation: {
      required: true,
      min: 1,
      max: 35,
    },
    ref: lastNameRef,
    // width: '95%',
    width: props?.fullWidth ? '100%' : '95%',
  };

  const prefixValidationObject = {
    name: 'displayPrefix',
    value: humanNameState?.displayPrefix,
    label: 'Title',
    ref: prefixRef,
    optionsList: humanNamePrefixOptionsOptionsList,
    // width: `90%`,
    width: props?.fullWidth ? '100%' : '90%',
    freeSolo: true,
  };

  const suffixValidationObject = {
    name: 'displaySuffix',
    value: humanNameState?.displaySuffix,
    label: 'Suffix',
    ref: suffixRef,
    optionsList: humanNameSuffixOptionsList.filter(option => {
      for (const stateOption of humanNameState?.displaySuffix) {
        if (
          option.code.toLowerCase() === stateOption.code.toLowerCase() &&
          option.display === stateOption.display
        ) {
          // Exclude the option if it is present in humanNameState
          return false;
        }
      }
      // Include the option if it is not present in humanNameState
      return true;
    }),
    // width: `90%`,
    width: props?.fullWidth ? '100%' : '90%',
    freeSolo: true,
    multiple: true,
  };

  useImperativeHandle(ref, () => ({
    handleOnUpdate() {
      // debugger;
      let exportParam = {};
      // if (isEdit) {
      exportParam.use = 'official';
      exportParam.family = humanNameState?.lastName?.trim();
      // let prefixDisplay =
      //   humanNamePrefixOptionsOptionsList?.[
      //     _.findIndex(
      //       humanNamePrefixOptionsOptionsList,
      //       o => o?.code === humanNameState?.displayPrefix
      //     )
      //   ];

      // let suffixDisplay =
      //   humanNameSuffixOptionsList?.[
      //     _.findIndex(
      //       humanNameSuffixOptionsList,
      //       o => o?.code === humanNameState?.displaySuffix
      //     )
      //   ];

      let prefixDisplay = humanNameState?.displayPrefix;

      let suffixDisplayList = humanNameState?.displaySuffix;

      let humanFullName = `${humanNameState?.firstName?.trim()} ${
        !_.isEmpty(humanNameState?.middleName)
          ? humanNameState?.middleName?.trim()
          : ''
      } ${humanNameState?.lastName?.trim()}`;

      if (
        prefixDisplay?.display &&
        !prefixDisplay?.display.includes('--') &&
        prefixDisplay?.display !== 'None'
      ) {
        exportParam.text = `${prefixDisplay?.display} ${humanFullName}`;
      } else {
        exportParam.text = `${humanFullName}`;
      }

      if (!_.isEmpty(suffixDisplayList)) {
        let suffixText = suffixDisplayList?.reduce((sentence, word) => {
          return sentence + ` ${word?.display}`;
        }, '');
        exportParam.text = `${exportParam?.text}, ${suffixText}`;
      }

      // if (
      //   suffixDisplay?.display &&
      //   suffixDisplay?.display !== 'None' &&
      //   !suffixDisplay?.display.includes('--')
      // ) {
      //   exportParam.text = `${exportParam.text} ${suffixDisplay?.display}`;
      // }

      // } else {
      //   exportParam.use = humanNameState?.use;
      //   exportParam.family = humanNameState?.family;
      //   exportParam.text = humanNameState?.text;
      // }
      exportParam.prefix = [prefixDisplay?.display];
      exportParam.suffix = humanNameState?.displaySuffix?.map(
        item => item?.display
      );
      exportParam.given = [
        humanNameState?.firstName?.trim(),
        humanNameState?.middleName?.trim(),
        humanNameState?.lastName?.trim(),
      ];

      let validationData = [];

      validationData.push(prefixRef?.current?.onValidate());
      validationData.push(suffixRef?.current?.onValidate());
      validationData.push(firstNameRef?.current?.onValidate());
      validationData.push(middleNameRef?.current?.onValidate());
      validationData.push(lastNameRef?.current?.onValidate());

      let valid = true;

      for (let item of validationData) {
        let validFlag = item?.valid ? item?.valid : item?.isValid;
        if (!validFlag) {
          valid = false;
          break;
        }
      }

      exportParam.valid = valid;
      exportParam.isStateChanged = isStateChanged;

      return exportParam;
    },
  }));

  useEffect(() => {
    // debugger;
    let suffixList = humanNameState?.displaySuffix;
    for (let i = 0; i < suffixList.length; i++) {
      if (suffixList[i]?.code.trim() === '' || suffixList[i]?.code === '') {
        suffixList.splice(i, 1);
        setHumanNameState({
          ...humanNameState,
          displaySuffix: suffixList,
        });
      }
    }
  }, [humanNameState]);

  useEffect(() => {
    console.log(`HMNX`, humanNameState);
  }, [humanNameState]);

  const handleOnChange = event => {
    const { name, value } = event?.target;

    let newValue = value;
    if (name === 'firstName' || name === 'lastName') {
      newValue = capitalizeFirstLetter(value);
    }

    setHumanNameState({
      ...humanNameState,
      [name]: newValue,
    });
  };

  useEffect(() => {
    setHumanNameState(humanNameInitalState(props?.nameObject));
  }, [props?.nameObject]);

  useEffect(() => {
    console.log(`humanName`, humanNameState);
  }, [humanNameState]);

  useEffect(() => {
    if (npiData && Object.keys(npiData.data).length > 0) {
      let npi = npiData.data;
      if (npi.addresses.length > 1) {
        // debugger;
        if (
          npi?.basic?.name_prefix &&
          npi?.basic?.name_prefix !== '' &&
          npi?.basic?.name_prefix !== '--'
        ) {
          const displayPrefix = npi?.basic?.name_prefix
            ? {
                code: npi?.basic?.name_prefix,
                display: npi?.basic?.name_prefix,
              }
            : { code: '', display: '' };

          const displaySuffix =
            npi?.basic?.name_suffix !== '' &&
            npi?.basic?.name_suffix !== '--' &&
            npi?.basic?.name_suffix
              ? [
                  {
                    code: npi?.basic?.name_suffix,
                    display: npi?.basic?.name_suffix,
                  },
                ]
              : npi?.basic?.credential
              ? [
                  {
                    code: npi?.basic?.credential,
                    display: npi?.basic?.credential,
                  },
                ]
              : [] || [];

          setHumanNameState({
            ...humanNameState,
            firstName: npi?.basic.first_name,
            middleName: npi?.basic.middle_name,
            lastName: npi?.basic.last_name,
            displayPrefix,
            displaySuffix,
            // displayPrefix: npi?.basic?.name_prefix ? {code:npi?.basic?.name_prefix?.toLowerCase()
            //     .replace('.', ''), display: npi?.basic?.name_prefix?.toLowerCase()
            //     .replace('.', '') }:{code:'', display:''},
            // displayPrefix:  npi?.basic?.name_prefix
            //   ?.toLowerCase()
            //   .replace('.', ''),
            // displaySuffix:
            //   npi?.basic?.name_suffix !== '' && npi?.basic?.name_suffix !== '--'
            //     ? npi?.basic?.name_suffix
            //     : npi?.basic?.credential || '',
            // displaySuffix:
            //   npi?.basic?.name_suffix !== '' && npi?.basic?.name_suffix !== '--'
            //     ? [npi?.basic?.name_suffix]
            //     : [npi?.basic?.credential] || [],
          });
        } else {
          const displaySuffix =
            npi?.basic?.name_suffix !== '' &&
            npi?.basic?.name_suffix !== '--' &&
            npi?.basic?.name_suffix
              ? [
                  {
                    code: npi?.basic?.name_suffix,
                    display: npi?.basic?.name_suffix,
                  },
                ]
              : npi?.basic?.credential
              ? [
                  {
                    code: npi?.basic?.credential,
                    display: npi?.basic?.credential,
                  },
                ]
              : [] || [];
          setHumanNameState({
            ...humanNameState,
            firstName: npi?.basic.first_name,
            middleName: npi?.basic.middle_name,
            lastName: npi?.basic.last_name,
            // displaySuffix:
            //   npi?.basic?.name_suffix !== '' && npi?.basic?.name_suffix !== '--'
            //     ? npi?.basic?.name_suffix
            //     : npi?.basic?.credential || '',
            displaySuffix,
          });
        }
      }
    }
  }, [npiData]);

  const validateFields = () => {
    if (
      humanNameState?.firstName?.length > 1 &&
      humanNameState?.firstName?.length < 35
    ) {
    }
  };

  return (
    <>
      <Grid sx={{ border: '0px solid red' }} container>
        <Grid xs={12} sx={{ border: '0px solid black' }} item>
          <Grid container spacing={2}>
            <Grid item sx={12}>
              <Grid container>
                <Grid item sx={12}>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {props?.customTitle ? (
                      props?.customTitle
                    ) : (
                      <>
                        <AddCircleIcon />
                        <Typography>Name</Typography>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          spacing={1}
          sm={12}
          sx={{ border: '0px solid black' }}
          container
          item
        >
          <Grid sx={{ border: '0px solid pink' }} item sm={4}>
            {/* <SelectWithTopLabelComponent
              onChange={handleOnChange}
              {...prefixValidationObject}
            /> */}
            <AutoCompleteWithTopLabel
              onChange={event => {
                const { name, value } = event?.target;
                let finalValue = value;
                if (typeof finalValue === 'string') {
                  finalValue = {
                    code: value,
                    display: value,
                  };
                }
                setHumanNameState({
                  ...humanNameState,
                  [name]: finalValue,
                });
              }}
              onInputValueChange={event => {
                const { name, value } = event?.target;
                setHumanNameState({
                  ...humanNameState,
                  [name]: value,
                });
              }}
              {...prefixValidationObject}
            />
          </Grid>
          <Grid item sm={4}>
            <AutoCompleteWithTopLabel
              onInputValueChange={event => {
                // const { name, value } = event?.target;
                // setHumanNameState({
                //   ...humanNameState,
                //   [name]: value,
                // });
              }}
              onChange={event => {
                const { name, value } = event?.target;
                const finalValue = value?.map(item => {
                  if (typeof item === 'string') {
                    return { code: item, display: item };
                  }
                  return item;
                });
                setHumanNameState({
                  ...humanNameState,
                  [name]: finalValue,
                });
              }}
              onBlur={event => {
                // debugger;
                const { value } = event?.target;
                if (!_.isUndefined(value) && value !== '') {
                  let suffixList = [...humanNameState?.displaySuffix]; // Copy the array
                  suffixList.push({
                    code: value,
                    display: value,
                  });

                  if (suffixList[0]?.length === 0) {
                    suffixList.shift();
                  }

                  setHumanNameState({
                    ...humanNameState,
                    displaySuffix: suffixList,
                  });
                }
              }}
              {...suffixValidationObject}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid spacing={1} sx={{ border: '0px solid black' }} container>
          <Grid item sm={4}>
            {isEdit ? (
              <TextFieldWithTopLabelComponent
                onChange={handleOnChange}
                {...firstNameValidationObject}
              />
            ) : (
              // textFieldWithTopLabel({
              //     name: "firstName",
              //     label: "First Name",
              //     width: "95%",
              //     value: humanNameState?.firstName,
              //     onChange: handleOnChange,
              //   })
              paperWithTopLabelAndBottomValue({
                label: 'First Name',
                value: humanNameState?.firstName,
              })
            )}
          </Grid>
          <Grid item sm={4}>
            {isEdit ? (
              <TextFieldWithTopLabelComponent
                onChange={handleOnChange}
                {...middleNameValidationObject}
              />
            ) : (
              // textFieldWithTopLabel({
              //     name: "middleName",
              //     label: "Middle Name",
              //     width: "95%",
              //     value: humanNameState?.middleName,
              //     onChange: handleOnChange,
              //   })
              paperWithTopLabelAndBottomValue({
                label: 'Middle Name',
                value: humanNameState?.middleName,
              })
            )}
          </Grid>
          <Grid item sm={4}>
            {isEdit ? (
              <TextFieldWithTopLabelComponent
                onChange={handleOnChange}
                {...lastNameValidationObject}
              />
            ) : (
              // textFieldWithTopLabel({
              //     name: "lastName",
              //     label: "Last Name",
              //     width: "95%",
              //     value: humanNameState?.lastName,
              //     onChange: handleOnChange,
              //   })
              paperWithTopLabelAndBottomValue({
                label: 'Last Name',
                value: humanNameState?.lastName,
              })
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
      </Grid>
    </>
  );
});

export default FHIRHumanName;
